import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import PageLoader from "../../../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";
import { selectTenantOpennetworkCategoriesListItems, selectOpennetworkCategoryCreatedItem, selectOpennetworkCategoryUpdatedItem } from "../../../../../../redux/tenant-open-network-categories/selector";
import { tenantOpenNetworkCategories } from "../../../../../../redux/tenant-open-network-categories/action";
import Popup from "../../../../../../common/components/popup";
import OpenNetworkCategoriesList from "../components/dbn-global-categories-list";
import { selectOpennetworkCategoriesListItems } from "../../../../../../redux/opennetwork-categories/selector";
import { opennetworkCategories } from "../../../../../../redux/opennetwork-categories/action";
import _ from "lodash";
import { opennetworkDomains } from "../../../../../../redux/opennetwork-domains/action";
import { selectOpennetworkDomainsListItems } from "../../../../../../redux/opennetwork-domains/selector";
import { deepCopy } from "../../../../../../common/services/common.service";
import Table from "../../../../../../common/components/table-manager/v1.1/table";

const DBNCategories = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);

  const itemsData = useSelector(selectTenantOpennetworkCategoriesListItems)
  const createItemData = useSelector(selectOpennetworkCategoryCreatedItem)
  const updateItemData = useSelector(selectOpennetworkCategoryUpdatedItem)
  // const categoriesListData = useSelector(selectOpennetworkCategoriesListItems)
  const domainsListData = useSelector(selectOpennetworkDomainsListItems)

  const [dbnDomainsList, setDbnDomainsList] = useState<any>([]);
  // const [dbnCategoriesList, setDbnCategoriesList] = useState<any>([]);
  const [initiallySelectedDomains, setInitiallySelectedDomains] = useState<any>([]);
  const [showDbnCategoriesPopup, setShowDbnCategoriesPopup] = useState<any>(false);

  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text' },
      { field: 'Code', headerName: 'Code', searchField: 'Code', sortable: true, filter: true, filterType: 'text' },
      { field: 'IsSubCategory', headerName: 'Is SubCategory', cellRenderer: 'yesNoRenderer', searchField: 'IsSubCategory', sortable: true, filter: true, filterType: 'text' },
      { field: 'ParentCategoryName', headerName: 'Parent Category', searchField: 'ParentCategoryName', sortable: true, filter: true, filterType: 'text' },
      { field: 'EdgeDBNDomainName', headerName: 'Domain', searchField: 'EdgeDBNDomainName', sortable: true, filter: true, filterType: 'text' },

    ]);
  }

  const getDomainName = (data: any) => {
    const domain: any = _.find(dbnDomainsList, ['Id', data])
    return domain?.Name
  }

  const handleAdd = () => {
    setShowDbnCategoriesPopup(true)
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.EdgeDBNCategoryId}`)
  }

  const addSelectedCatgories = async (data: any) => {

    const dt = _.flatMap(data, (item: any) => {
      return _.map(item?.EntityAttributeValueMappings, (mapping: any) => {
        // _.map(mapping?.EntityAttributes, (attribute: any) => {

        return {
          "Id": 0,
          "EntityAttributeName": mapping.EntityAttributeName,
          "EntityAttributeValue": mapping.EntityAttributeValue,
          "EntityAttributeTypeId": mapping.EntityAttributeTypeId,
          // "OwnerTypeId": 0,
          // "OwnerId": 0,
          // "MappedEntityTypeId": 0,
          // "MappedEntityId": 0
        }
        // })
      })
    })


    const items = _.flatMap(data, (item: any) => {
      return {
        "Name": item?.Name,
        "IsSubCategory": item?.IsSubCategory,
        "ParentCategoryId": item?.ParentCategoryId,
        "Code": item?.Code,
        "TenantOpenNetworkDomainId": item?.OpenNetworkDomainId,
        "FunctionAttributes": [],
        "EntityAttributes": _.map(item?.EntityAttributeValueMappings, (mapping: any) => {
          // _.map(mapping?.EntityAttributes, (attribute: any) => {
          return {
            "Id": 0,
            "EntityAttributeName": mapping.EntityAttributeName,
            "EntityAttributeValue": mapping.EntityAttributeValue,
            "EntityAttributeTypeId": mapping.EntityAttributeTypeId,
            // "OwnerTypeId": 0,
            // "OwnerId": 0,
            // "MappedEntityTypeId": 0,
            // "MappedEntityId": 0
          }
          // })
        })
      }
    })

    dispatch(tenantOpenNetworkCategories.resetAction({ actionType: 'create' }))
    await dispatch(tenantOpenNetworkCategories.create({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-categories`,
      entity: 'tenantOpenNetworkCategories',
      jsonData: {
        Context: {},
        Records: items
      }
    }))
  }

  const handleDelete = async (data: any) => {
    dispatch(tenantOpenNetworkCategories.resetAction({ actionType: 'delete' }))
    await dispatch(tenantOpenNetworkCategories.delete({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-categories/delete`,
      entity: 'tenantOpenNetworkCategories',
      jsonData: {
        Context: {},
        Records: [
          {
            Id: data?.EdgeDBNCategoryId
          }
        ]
      }
    }))

    listTenantOpenNetworkCategories();
  }



  const listTenantOpenNetworkCategories = () => {
    dispatch(tenantOpenNetworkCategories.resetAction({ actionType: 'list' }))
    dispatch(tenantOpenNetworkCategories.list({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-categories/dbn-fetch`,
      entity: 'tenantOpenNetworkCategories',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  const listOpenNetworkDomains = () => {
    dispatch(opennetworkDomains.resetAction({ actionType: 'list' }))
    dispatch(opennetworkDomains.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains/dbn-fetch`,
      entity: 'tenantOpenNetworkDomains',
      jsonData: {
        "Context": {},
        "Records": [
          {
            "IsSubDomain": null //to get all records 
          }
        ],
        "Pagination": {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "GlobalDBNDomainId",
          "SortOrder": "desc",
        }
      }
    }))
  }

  // const listDBNGlobalCagtegories = () => {
  //   dispatch(opennetworkCategories.resetAction({ actionType: 'list' }))
  //   dispatch(opennetworkCategories.list({
  //     url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-categories/dbn-fetch`,
  //     entity: 'tenantOpenNetworkDomains',
  //     jsonData: {
  //       "PageNumber": pageData,
  //       "PageSize": pageSize,
  //       "SortField": "Id",
  //       "SortOrder": "desc",
  //     }
  //   }))
  // }

  // const reloadGlobalCategories = async () => {
  //   listDBNGlobalCagtegories()
  // }

  const handleDBNGlobalCategoriesSearch = (data: any) => {

    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(opennetworkCategories.resetAction({ actionType: 'list' }))
    dispatch(opennetworkCategories.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-categories/dbn-fetch`,
      entity: 'opennetworkCategories',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }


  useEffect(() => {
    createColumnDefs()
    // listDBNGlobalCagtegories();
    listOpenNetworkDomains();
    listTenantOpenNetworkCategories();
  }, [pageData, pageSize])

  useEffect(() => {
    setDbnDomainsList(domainsListData?.result?.items)
  }, [domainsListData]);

  // useEffect(() => {
  //   console.log('categoriesListData', categoriesListData)
  //   setDbnCategoriesList(categoriesListData?.result?.items)
  // }, [categoriesListData]);

  const handlePublishDBNCategories = async () => {
    await dispatch(opennetworkCategories.resetAction({ actionType: 'publish' }))
    await dispatch(opennetworkCategories.publish({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-categories/dbn-publish`,
      entity: 'opennetworkCategories',
      jsonData:
      {
        Context: {},
        Records: [{}]
      }
    })).then(() => {
      listTenantOpenNetworkCategories();
    });
  }

  useEffect(() => {
    if (createItemData?.isSuccess || updateItemData?.isSuccess) {
      listTenantOpenNetworkCategories();
    }
  }, [createItemData, updateItemData]);

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Catgeory</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      // name: 'Add Catgeory',
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
          <title>Publish DBN Categories</title>
          <path d="M17.4776 9.01106C17.485 9.01102 17.4925 9.01101 17.5 9.01101C19.9853 9.01101 22 11.0294 22 13.5193C22 15.8398 20.25 17.7508 18 18M17.4776 9.01106C17.4924 8.84606 17.5 8.67896 17.5 8.51009C17.5 5.46695 15.0376 3 12 3C9.12324 3 6.76233 5.21267 6.52042 8.03192M17.4776 9.01106C17.3753 10.1476 16.9286 11.1846 16.2428 12.0165M6.52042 8.03192C3.98398 8.27373 2 10.4139 2 13.0183C2 15.4417 3.71776 17.4632 6 17.9273M6.52042 8.03192C6.67826 8.01687 6.83823 8.00917 7 8.00917C8.12582 8.00917 9.16474 8.38194 10.0005 9.01101" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M12 13L12 21M12 13C11.2998 13 9.99153 14.9943 9.5 15.5M12 13C12.7002 13 14.0085 14.9943 14.5 15.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handlePublishDBNCategories(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    },
  ];

  const closeModal = () => {
    setShowDbnCategoriesPopup(false)
  }

  const handleSubmit = (data: any) => {
    addSelectedCatgories(data);
    closeModal();
  }

  const LoadOpenNetworkCategoriesList = () => {
    return (
      <Popup onClose={closeModal}>
        <OpenNetworkCategoriesList
          // openNetworkDomains={dbnDomainsList}
          // openNetworkCategories={dbnCategoriesList}
          // paginationData={categoriesListData?.result?.pagination}
          initiallySelectedCategories={itemsData?.result?.items}
          // handleDBNGlobalCategoriesSearch={handleDBNGlobalCategoriesSearch}
          // reloadGlobalCategories={reloadGlobalCategories}
          handleSubmit={handleSubmit}
          closeModal={closeModal}
        />
      </Popup>
    )
  }

  useEffect(() => {
    // console.log('itemsData', itemsData)
  }, [itemsData]);

  const handleReloadData = () => {
    listTenantOpenNetworkCategories();
  }

  const handleSearch = (data: any) => {

    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(tenantOpenNetworkCategories.resetAction({ actionType: 'list' }))
    dispatch(tenantOpenNetworkCategories.list({
      url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-categories/dbn-fetch`,
      entity: 'tenantOpenNetworkCategories',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }

  const handleSelect = (data: any) => {
    // console.log("data", data)
  }

  const handleSelectAll = (items: any[], checked: any) => {
    // console.log("Items count", checked, items?.length)
    // console.log('items', items)
  }

  return (
    <>
      {showDbnCategoriesPopup ? <LoadOpenNetworkCategoriesList /> : <></>}
      {itemsData?.isLoading ?
        <PageLoader /> :
        <Table
          columnData={columnDefs}
          rowData={itemsData?.result?.items}
          setPageData={setPageData}
          setPageSize={setPageSize}
          enableFilter={true}
          onSearch={handleSearch}
          onSelect={handleSelect}
          paginationData={itemsData?.result?.pagination}
          onEdit={handleEdit}
          onDelete={handleDelete}
          additionButtons={additionButtons}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          headingName="DBN Taxonomy Categories" />
      }
    </>
  );
};

export default DBNCategories;
